import React from "react";
import '../Styles/MedicalComboRegister.scss';
import InputValidation from "../Helper/InputValidation.js";

function MedicalInsuranceInformation({ medicalInformation, setMedicalInformation, selectedPage, setSelectedPage, previousPage, nextPage }) {

   function handleChange(member, isSet) {
      const keys = Object.keys(medicalInformation)
      const key = keys.find(element => element === member)
      setMedicalInformation({ ...medicalInformation, [key]: (isSet) })
   }

   const preexistingConditionsColumn1 = [
      { display: "Diabetes/Hypoglycemia", value: "hasDiabetes" },
      { display: "Heart condition/problems", value: "hasHeartCondition" },
      { display: "Epilepsy", value: "hasEpilepsy" },
      { display: "Environmental Allergies", value: "hasEnvironmentAllergies" },
      { display: "Heat exhaustion/problems", value: "hasHeatExhaustion" },
   ];
   const preexistingConditionsColumn2 = [
      { display: "Thyroid Problems", value: "hasThyroidProblem" },
      { display: "Lupus", value: "hasLupus" },
      { display: "High Blood Pressure", value: "hasHighBloodPressure" },
      { display: "Asthma", value: "hasAsthma" },
   ];

   return (
      <div className="InsuranceMedicalContent">
         <div className="InsuranceMedicalHeading">
            Medical and Insurance Information
         </div>
         <h4>Insurance Info</h4>
         <div className='companyID'>
            <div className='companyIDInput'>
               <label>Insurance Company: </label>
               <input
                  type="text"
                  value={medicalInformation.insuranceCompany}
                  onChange={(event) =>
                     setMedicalInformation({ ...medicalInformation, insuranceCompany: event.target.value })
                  }
               />
            </div>
            <div className='companyIDInput'>
               <label>ID Number: </label>
               <input
                  type="text"
                  value={medicalInformation.insuranceId}
                  onChange={(event) =>
                     setMedicalInformation({ ...medicalInformation, insuranceId: InputValidation.ValidateInputForInsuranceNumbers(event.target.value) })
                  }
               />
            </div>
         </div>
         <div className="numberName">
            <div className='numberNameInput'>
               <label>Group Policy Number: </label>
               <input
                  type="text"
                  value={medicalInformation.groupPolicyNumber}
                  onChange={(event) =>
                     setMedicalInformation({ ...medicalInformation, groupPolicyNumber: InputValidation.ValidateInputForInsuranceNumbers(event.target.value) })
                  }
               />
            </div>
            <div className='numberNameInput'>
               <label>Name of Policy Holder:</label>
               <input
                  type="text"
                  value={medicalInformation.policyHolderName}
                  onChange={(event) =>
                     setMedicalInformation({ ...medicalInformation, policyHolderName: event.target.value })
                  }
               />
            </div>
         </div>
         <div className='birthdayStatus'>
            <div className='birthdayInput'>
               <label>Birthdate of Policy Holder:</label>
               <input
                  type="date"
                  value={medicalInformation.policyHolderBirthdate}
                  onChange={(event) =>
                     setMedicalInformation({ ...medicalInformation, policyHolderBirthdate: event.target.value })
                  }
               />
            </div>
         </div>
         <hr></hr>
         <h4>Medical Info</h4>
         <p>Preexisting Conditions: <br />
            Please check the appropriate box/boxes <br />
            This will be kept confidential
         </p>
         <div className="preConditionsCheckboxes">
            <div className="preConditionsCheckboxesColumn1">
               {preexistingConditionsColumn1.map((condition, index) => (
                  <div key={index} className="preConditionsCheckboxesInput">
                     <input
                        type="checkbox"
                        onChange={(event) => handleChange(condition.value, event.target.checked)}
                        checked={medicalInformation[condition.value] === true}
                     />
                     <>&nbsp;&nbsp;&nbsp;</>
                     {condition.display}
                  </div>
               ))}
            </div>
            <div className="preConditionsCheckboxesColumn2">
               {preexistingConditionsColumn2.map((condition, index) => (
                  <div key={index} className="preConditionsCheckboxesInput">
                     <input
                        type="checkbox"
                        onChange={(event) => handleChange(condition.value, event.target.checked)}
                        checked={medicalInformation[condition.value] === true}
                     />
                     <>&nbsp;&nbsp;&nbsp;</>
                     {condition.display}
                  </div>
               ))}
            </div>
         </div>
         <div className='allergiesFirstRow'>
            <div className='AllergiesInput'>
               <label>Drug Allergy Name: </label>
               <input
                  type="text"
                  value={medicalInformation.drugAllergies}
                  onChange={(event) => setMedicalInformation({ ...medicalInformation, drugAllergies: event.target.value })}
               />
               <label>Emergency Action Taken:</label>
               <input
                  type="text"
                  value={medicalInformation.emergencyAction1}
                  onChange={(event) => setMedicalInformation({ ...medicalInformation, emergencyAction1: event.target.value })}
               />
            </div>
            <div className='AllergiesInput'>
               <label>Food Allergy Name: </label>
               <input
                  type="text"
                  value={medicalInformation.foodAllergies}
                  onChange={(event) => setMedicalInformation({ ...medicalInformation, foodAllergies: event.target.value })}
               />
               <label>Emergency Action Taken:</label>
               <input
                  type="text"
                  value={medicalInformation.emergencyAction2}
                  onChange={(event) => setMedicalInformation({ ...medicalInformation, emergencyAction2: event.target.value })}
               />
            </div>
         </div>
         <div className="allergiesSecondRow">
            <div className='allergiesRow2Input'>
               <label>Other Allergy Name: </label>
               <input
                  type="text"
                  value={medicalInformation.otherAllergies}
                  onChange={(event) => setMedicalInformation({ ...medicalInformation, otherAllergies: event.target.value })}
               />
               <label>Emergency Action Taken:</label>
               <input
                  type="text"
                  value={medicalInformation.emergencyAction3}
                  onChange={(event) => setMedicalInformation({ ...medicalInformation, emergencyAction3: event.target.value })}
               />
            </div>
            <div className='allergiesRow2Input'>
               <label>Medication Name: </label>
               <input
                  type="text"
                  value={medicalInformation.medicationName}
                  onChange={(event) => setMedicalInformation({ ...medicalInformation, medicationName: event.target.value })}
               />
               <label>Medication Dose:</label>
               <input
                  type="text"
                  value={medicalInformation.medicationDose}
                  onChange={(event) => setMedicalInformation({ ...medicalInformation, medicationDose: event.target.value })}
               />
            </div>
         </div>
         <div className="medicationsTextBoxes">
            <div className='medicationsTextBoxesInput'>
               <label>Date of last tetanus shot:</label>
               <input
                  type="date"
                  value={medicalInformation.tetanusShotDate}
                  onChange={(event) =>
                     setMedicalInformation({ ...medicalInformation, tetanusShotDate: event.target.value })
                  }
               />
            </div>
         </div>
         <div className="medicalInsuranceButtonsContainer">
            <div className="medicalInsuranceButtons">
               <div className='medicalInsurancePreviousButton'>
                  <button className='prevButton' onClick={() => setSelectedPage(previousPage)}>
                     Previous
                  </button>
               </div>
               <div className="medicalInsuranceNextButton">
                  <button className="nextButton" type='button' onClick={() => setSelectedPage(nextPage)}>
                     Next
                  </button>
               </div>
            </div>
         </div>
      </div>
   )
}

export default MedicalInsuranceInformation;
